<template>
  <form>
    <v-row>
      <v-col cols="12" sm="12" md="11" lg="11">
        <v-row>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-row>
              <v-col cols="4" sm="4" md="4" lg="4">
                <v-subheader>Edited Type</v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6">
                <v-select outlined flat dense background-color="white"></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" sm="4" md="4" lg="4">
                <v-subheader>Asset <span class="red--text">*</span></v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6">
                <v-autocomplete
                  outlined
                  flat
                  dense
                  background-color="white"
                  append-icon="mdi-magnify"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" sm="4" md="4" lg="4">
                <v-subheader>Last journal Date</v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6">
                <v-menu
                  v-model="menuStart"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      outlined
                      flat
                      dense
                      background-color="white"
                      v-model="dateStart"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      disabled
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="dateStart" @input="menuStart = false"></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" sm="4" md="4" lg="4">
                <v-subheader>Last Book Value</v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6">
                <v-text-field outlined flat dense background-color="white" disabled></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-row>
              <v-col cols="4" sm="4" md="4" lg="4">
                <v-subheader>Number <span class="red--text">*</span></v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6">
                <v-text-field outlined flat dense background-color="white"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" sm="4" md="4" lg="4">
                <v-subheader>Date <span class="red--text">*</span></v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="6" lg="6">
                <v-menu
                  v-model="menuStart"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      outlined
                      flat
                      dense
                      background-color="white"
                      v-model="dateStart"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="dateStart" @input="menuStart = false"></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-tabs vertical>
            <v-tab>
              <v-icon>
                mdi-note-text
              </v-icon>
            </v-tab>
            <v-tab>
              <v-icon>
                mdi-database-plus
              </v-icon>
            </v-tab>
            <v-tab>
              <v-icon>
                mdi-information
              </v-icon>
            </v-tab>
            <v-tab-item>
              <v-card flat outlined>
                <v-card-title class="font-italic">General information</v-card-title>
                <v-row>
                  <v-col cols="12" sm="12" md="6" lg="6">
                    <v-row>
                      <v-col cols="4" sm="4" md="5" lg="5">
                        <v-subheader>Depreciation Method</v-subheader>
                      </v-col>
                      <v-col cols="8" sm="8" md="6" lg="6">
                        <v-select outlined flat dense background-color="white"></v-select>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="4" sm="4" md="5" lg="5">
                        <v-subheader>Residual value</v-subheader>
                      </v-col>
                      <v-col cols="8" sm="8" md="6" lg="6">
                        <v-text-field
                          outlined
                          flat
                          dense
                          background-color="white"
                          prefix="Rp"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="4" sm="4" md="5" lg="5">
                        <v-subheader>Description</v-subheader>
                      </v-col>
                      <v-col cols="8" sm="8" md="6" lg="6">
                        <v-textarea outlined flat rows="3" background-color="white"></v-textarea>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card outlined flat class="px-2">
                <v-row>
                  <v-col cols="5">
                    <v-autocomplete
                      outlined
                      flat
                      dense
                      background-color="white"
                      placeholder="Find/Choose Account"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="7" align-self="start" class="text-right">
                    <p class="headline font-italic">
                      Expense
                    </p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" class="py-0">
                    <v-data-table
                      :headers="headers"
                      :items="items"
                      disable-pagination
                      hide-default-footer
                    ></v-data-table>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat outlined>
                <v-card-title class="font-italic">Other Info</v-card-title>
                <v-row>
                  <v-col cols="12" sm="12" md="6" lg="6">
                    <v-row>
                      <v-col cols="4" sm="4" md="3" lg="3">
                        <v-subheader>Intangible Asset</v-subheader>
                      </v-col>
                      <v-col cols="8" sm="8" md="6" lg="6">
                        <v-checkbox label="Yes"></v-checkbox>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="4" sm="4" md="3" lg="3">
                        <v-subheader>Department</v-subheader>
                      </v-col>
                      <v-col cols="8" sm="8" md="6" lg="6">
                        <v-autocomplete
                          outlined
                          flat
                          dense
                          background-color="white"
                          append-icon="mdi-magnify"
                        ></v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="4" sm="4" md="3" lg="3">
                        <v-subheader>Asset Account</v-subheader>
                      </v-col>
                      <v-col cols="8" sm="8" md="6" lg="6">
                        <v-autocomplete
                          outlined
                          flat
                          dense
                          background-color="white"
                          append-icon="mdi-magnify"
                        ></v-autocomplete>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6">
                    <v-row>
                      <v-col cols="4" sm="4" md="3" lg="3">
                        <v-subheader>Fiscal</v-subheader>
                      </v-col>
                      <v-col cols="8" sm="8" md="6" lg="6">
                        <v-checkbox label="Yes"></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-row>
        <v-row class="py-0">
          <v-spacer></v-spacer>
          <v-col cols="2">
            <v-card outlined>
              <v-card-title>Total Asset</v-card-title>
              <v-card-text class="text-right">
                <p>Rp. 0</p>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="2">
            <v-card outlined>
              <v-card-title>Book Value</v-card-title>
              <v-card-text class="text-right">
                <p>Rp. 0</p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="12" md="1" lg="1">
        <v-row>
          <v-col cols="12">
            <v-btn color="primary">
              <v-icon>mdi-content-save</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </form>
</template>

<script>
export default {};
</script>

<style></style>
